export default {
  appSettings: 'App-Einstellungen',
  userSettings: 'Benutzereinstellungen',
  tenantSettings: 'Qmulus-Einstellungen',
  APIKey: 'API Keys',
  notificationChannel: 'Benachrichtigungskanäle',
  userSubscription: 'Benutzer-Abonnements',
  channels: 'Kanäle',
  reportBuilder: 'Berichte',
  assetParameterDefinition: 'Asset-Parameterdefinitionen',
  pinnedApps: 'Angeheftete Apps',
};
